import React from 'react';
import { Space, Button, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import type { Dataset } from '../../../services/aiConfigService';

export const getColumns = (
  onEdit: (record: Dataset) => void,
  onDelete: (id: string) => void
) => [
  { title: '数据集ID', dataIndex: 'datasetId', key: 'datasetId', width: 200 },
  { title: '数据集名称', dataIndex: 'name', key: 'name', width: 200 },
  { title: '方法类型', dataIndex: 'methodType', key: 'methodType', width: 100 },
  { title: '方法名称', dataIndex: 'methodName', key: 'methodName', width: 200 },
  { title: '数据格式', dataIndex: 'dataFormat', key: 'dataFormat', width: 120 },
  {
    title: '是否启用',
    dataIndex: 'isActive',
    key: 'isActive',
    width: 100,
    render: (val: boolean) => (val ? '是' : '否'),
  },
  {
    title: '操作',
    key: 'action',
    width: 150,
    fixed: 'right' as const,
    render: (_: any, record: Dataset) => (
      <Space>
        <Button
          type="link"
          size="small"
          icon={<EditOutlined />}
          onClick={() => onEdit(record)}
          title="编辑"
        />
        <Popconfirm
          title="确定要删除该数据集吗？"
          onConfirm={() => onDelete(record.datasetId)}
        >
          <Button type="link" danger size="small" icon={<DeleteOutlined />} title="删除" />
        </Popconfirm>
      </Space>
    ),
  },
];

export const tableConfig = {
  rowKey: 'datasetId' as const,
  pagination: {
    pageSize: 20,
    showSizeChanger: true,
    showTotal: (total: number) => `共 ${total} 条`,
  },
};
